import { registerQuery } from 'data-fetching-client';
import { getSmsCrmObject } from '../api/getSmsCrmObject';
export const FETCH_SMS_FROM_ROOT_MIC_ID = registerQuery({
  fieldName: 'smsObject',
  args: ['rootMicId'],
  fetcher({
    rootMicId
  }) {
    return getSmsCrmObject(rootMicId);
  }
});